import { createSlice } from "@reduxjs/toolkit";

import { IConversationAnalysisSlice } from "../../models/admin/conversationAnalysis/conversationAnalysis";
import {
  getAllConversationSessions,
  getConversationAnalysis,
  getConversationByFilter,
  getConversationBySession,
} from "./ConversatonAnalysisActions";

const initialState: IConversationAnalysisSlice = {
  conversationMetrics: {
    totalMessages: 0,
    totalFeedback: 0,
    positiveFeedback: 0,
  },
  conversationAnalysisData: [],
  conversations: {},
  analysedReport: "",
};

const conversationAnalysisSlice = createSlice({
  name: "conversationAnalysis",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      getAllConversationSessions.fulfilled,
      (state, { payload }) => {
        state.conversationAnalysisData = payload?.data?.chatSessions;
        state.conversationMetrics = payload?.data?.metrics;
      }
    );

    builder.addCase(getConversationByFilter.fulfilled, (state, { payload }) => {
      state.conversationAnalysisData = payload?.data;
    });

    builder.addCase(getConversationAnalysis.fulfilled, (state, { payload }) => {
      state.analysedReport = payload?.data;
    });

    builder.addCase(
      getConversationBySession.fulfilled,
      (state, { payload }) => {
        state.conversations = payload?.data || {};
      }
    );
  },
});

export default conversationAnalysisSlice.reducer;
